import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAPI } from '@/hooks/useAPI'
import { getStudioById } from '@/services/api/studios'
import StudioDetail from './StudioDetail'

const StudioDetailPage = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  
  console.log('StudioDetailPage - id:', id)
  
  // 获取工作室详情数据
  const { data: studio, loading, error } = useAPI(
    () => {
      console.log('Calling getStudioById with id:', id)
      return getStudioById(id)
    },
    [id]
  )
  
  console.log('StudioDetailPage - data:', studio)
  console.log('StudioDetailPage - loading:', loading)
  console.log('StudioDetailPage - error:', error)

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">{t('common.loading')}</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="text-6xl mb-4">😔</div>
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            {t('common.error.title')}
          </h3>
          <p className="text-gray-600">
            {error || t('common.error.general')}
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-white">
      <StudioDetail studio={studio} />
    </div>
  )
}

export default StudioDetailPage